import { render, staticRenderFns } from "./addDedicatedDietQuestion.vue?vue&type=template&id=49b0b3f6&"
import script from "./addDedicatedDietQuestion.vue?vue&type=script&lang=js&"
export * from "./addDedicatedDietQuestion.vue?vue&type=script&lang=js&"
import style0 from "./addDedicatedDietQuestion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports